var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"favorite-wrapper"},[_c('button',{staticClass:"favorite-button",class:{ dark: _vm.dark },attrs:{"id":"dashboard.favorite.toggle"},on:{"click":_vm.onClick}},[(_vm.favorite)?_c('FavoriteIconFilled',{staticClass:"filled"}):_c('FavoriteIconOutlined',{staticClass:"outlined"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }